<template>
  <div class="cotainer-fluid">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          :name="$t('modal.form.name.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.name.label') }}
            <input
              v-model="form.name"
              :placeholder="$t('modal.form.name.placeholder')"
              type="text"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.name_ru.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.name_ru.label') }}
            <input
              v-model="form.name_ru"
              type="text"
              :placeholder="$t('modal.form.name_ru.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.address.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.address.label') }}
            <input
              id="address"
              v-model="form.address"
              type="text"
              :placeholder="$t('modal.form.address.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <div
          v-for="(num, index) in form.numbers"
          :key="index"
        >
          <ValidationProvider
            :name="$t('modal.form.numbers.label')"
            rules="required"
            v-slot="{ errors }"
          >
            <label>
              {{ $t('modal.form.numbers.label') }}
                <div class="d-flex">
                  <input
                    v-model="num.number"
                    v-mask="'###(##)###-##-##'"
                    type="text"
                    :placeholder="$t('modal.form.numbers.placeholder')"
                  >
                  <b-button
                    variant="outline-danger"
                    @click="deleteObject(index)"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </label>
          </ValidationProvider>
        </div>

        <div class="d-flex justify-content-end mb-2">
          <b-button
            variant="success"
            size="sm"
            @click="increaseNumber()"
          >
            <i class="bx bx-plus"></i>
          </b-button>
        </div>

        <b-button class="float-end ms-3"
          variant="primary" :disabled="dButton"
          type="submit"
        >
          {{ $t('modal.button.post') }}
        </b-button>

        <b-button class="float-end"
          variant="warning"
          @click="onClose()"
        >
          {{ $t('modal.button.back') }}
        </b-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { postDealers } from '../../../api/endpoints/dealers'

  export default {
    name: "DealersPostModal",
    data() {
      return {
        form: {
          name: "",
          name_ru: "",
          address: "",
          numbers: [{number: null}]
        },
        dButton: false,
      }
    },
    methods: {
      onSubmit() {
        this.dButton = true;
        setTimeout(() => {
          this.dButton = false;
        }, 700)
          this.form.numbers.forEach(el => {
              const e = el.number
              let mobile = e.replace(')', '');
              mobile = mobile.replace('+', '');
              mobile = mobile.replace('(', '');
              mobile = mobile.replace(/ /g, '');
              mobile = mobile.replace(/-/g, '');
              el.number = mobile;
          })
        postDealers(this.form).then( () => {
          this.onClose()
        })
      },
      onClose() {
        this.$emit('onClose')
      },
      deleteObject(index) {
        this.form.numbers.splice(index, 1)
      },
      increaseNumber() {
        this.form.numbers.push({
          number: null
        });
      }
    }
  }
</script>
